import {
  DEMO_CASE_5_TERM,
  DEMO_CASE_6_TERM,
  DEMO_CASE_7_TERM,
  EVALUATION_REFERENCE_DATE,
  MOCK_EVALUATION_TERMS,
  resolveEvaluationTerm,
  type EvaluationTerm,
} from "@/lib/mock/evaluation-dashboard"

export type DashboardDemoMode = "empty" | "case5" | "case6" | "case7" | null

export interface DashboardTermSlice {
  showNoTerms: boolean
  currentTerm?: EvaluationTerm
  lastTerm?: EvaluationTerm
  pastTerms: EvaluationTerm[]
  upcomingTerms: EvaluationTerm[]
  futureTerms: EvaluationTerm[]
  allTerms: EvaluationTerm[]
}

function allResolvedTerms(today: Date = EVALUATION_REFERENCE_DATE): EvaluationTerm[] {
  return MOCK_EVALUATION_TERMS.map(term => resolveEvaluationTerm(term, today))
}

export function parseDashboardDemo(search: string): DashboardDemoMode {
  if (typeof search !== "string") return null
  const params = new URLSearchParams(search.startsWith("?") ? search : `?${search}`)
  const demo = params.get("demo")
  if (demo === "empty") return "empty"
  if (demo === "case5") return "case5"
  if (demo === "case6") return "case6"
  if (demo === "case7") return "case7"
  return null
}

export function getDashboardTermSlice(
  search: string,
  today: Date = EVALUATION_REFERENCE_DATE,
): DashboardTermSlice {
  const demo = parseDashboardDemo(search)
  if (demo === "empty") {
    return {
      showNoTerms: true,
      pastTerms: [],
      upcomingTerms: [],
      futureTerms: [],
      allTerms: [],
    }
  }

  const terms = allResolvedTerms(today)
  const pastTerms = terms
    .filter(term => term.timelinePosition === "past")
    .sort((a, b) => a.startDate.localeCompare(b.startDate))

  let currentTerm = terms.find(term => term.timelinePosition === "current")
  if (demo === "case5") currentTerm = DEMO_CASE_5_TERM
  if (demo === "case6") currentTerm = DEMO_CASE_6_TERM
  if (demo === "case7") currentTerm = DEMO_CASE_7_TERM

  const allTerms = [...terms].sort((a, b) => {
    const timelineDelta = TIMELINE_SORT[a.timelinePosition] - TIMELINE_SORT[b.timelinePosition]
    if (timelineDelta !== 0) return timelineDelta
    return b.startDate.localeCompare(a.startDate)
  })

  return {
    showNoTerms: false,
    currentTerm,
    lastTerm: terms.find(term => term.timelinePosition === "last"),
    pastTerms,
    upcomingTerms: terms.filter(term => term.timelinePosition === "upcoming"),
    futureTerms: terms.filter(term => term.timelinePosition === "future"),
    allTerms,
  }
}

const TIMELINE_SORT: Record<EvaluationTerm["timelinePosition"], number> = {
  current: 0,
  last: 1,
  upcoming: 2,
  future: 3,
  past: 4,
}
